<template lang="jade">
  header
    a#headline(v-link="{ path: '/targets' }")
    a#tech-logo(v-link="{ path: '/' }")
      img(v-bind:src="logo")
  #header-bottom
  router-view
  section#bg
  footer
    h3 STAND WITH US. SUPPORT AN HDR FUTURE FOR ALL. 
      a(v-link="{ path: '/' }") technicolor.com/hdr 
</template>

<script>
  export default {
    data () {
      return {
        title: 'SHELL',
        logo: 'https://s3-us-west-1.amazonaws.com/db13/1440/tech-logo.svg'
      }
    }
  }
</script>

<style lang="sass?indentedSyntax">
  
  @import "../_sass/utilities/_utilities.sass"
  @import "../_sass/utilities/_animation.sass"

  section#bg
    @extend %tech-gradient
    position: fixed
    height: $container-height
    width: 100vw
    top: $container-pos
    z-index: 1

  header
    display: flex
    align-items: center
    height: 10rem
    width: 100vw
    position: fixed
    top: 0
    left: 0
    background-color: #fff
    z-index: 10000
    padding: 0 2rem

    a#tech-logo
      display: flex
      align-items: center
      margin-right: 0
      height: 10rem
      width: 18rem
      background-color: white
      padding: 0 2rem

    h1
      margin-left: auto
    
  #header-bottom
    @extend %tech-gradient
    width: 100vw
    height: calc(1rem + 1px)
    position: fixed
    top: 10rem
    left: 0
    z-index: 10000

  a#headline
    @extend %tech-gradient
    mask-image: url(../imgs/logos/advanced-hdr.svg) top left / cover
    -webkit-mask: url(../imgs/logos/advanced-hdr.svg) top left / cover
    width: 54rem
    position: relative
    z-index: 2
    height: 3.5rem
    margin-right: auto

  footer
    @extend %aligner
    @extend %box-shadow
    width: 100vw
    position: fixed
    bottom: 0
    height: 4rem
    background-color: $dk-grey
    z-index: 12000
    padding-right: 3rem
    h3
      color: $white
      font-size: 1.25rem
      margin-left: auto
      a
        color: $lime
        &:hover
          color: $yellow

</style>


/** WEBPACK FOOTER **
 ** app-shell.vue?2575d959
 **/